import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router";

import * as Api from "@/api";
import FabBar from "@/design/components/FabBar";
import MasterListVirtualized from "@/design/components/MasterListVirtualized";
import { disableSearch, enableSearch } from "@/store/reducers/ui";
import useSearch from "@/utils/hooks/useSearch";
import { toggleLoadingState } from "@/utils/utility";
import Valkyrie, { viList, viPlus } from "@sippy-platform/valkyrie";

import { useMediaQuery, useTheme } from "@mui/material";
import Button from "@mui/material/Button";

function QueueList() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const queueStore = useSelector((state) => state.domain.queues);
  const searchValue = useSelector((state) => state.ui.searchValue);
  const progressBar = useSelector((state) => state.ui.progressBar);

  // Search every time queueList or searchQuery changes
  const searchResults = useSearch(queueStore.list, searchValue, ["name", "exten"]);

  useEffect(() => {
    toggleLoadingState(true);
    Promise.resolve(Api.getQueues()).finally(toggleLoadingState);
  }, []);

  // Open first item or new if the viewport is large enough
  useEffect(() => {
    if (!id && matchesMdUp && queueStore.meta.lastFetched) {
      if (queueStore.list.length >= 1) {
        navigate(`${queueStore.list[0].id}`);
      } else {
        navigate("new");
      }
    }
  }, [id, matchesMdUp, navigate, queueStore.list, queueStore.meta.lastFetched]);

  useEffect(() => {
    dispatch(enableSearch());
  }, [dispatch]);
  useEffect(() => () => dispatch(disableSearch()), [dispatch]);

  return (
    <>
      <MasterListVirtualized
        fabBar
        title="Queues"
        aria-label="Queue list"
        id="queue-list"
        list={searchResults}
        listItemProps={{
          primary: (x) => x.name,
          secondary: (x) => x.exten,
          to: (x) => `../${x.id}`,
          selected: (x) => x.id === Number(id),
          icon: viList,
        }}
        hideContentLoader={queueStore.meta.count >= 1 && searchResults.length >= 1}
        contentLoaderProps={{
          count: queueStore.meta.count,
          loading: progressBar,
          noItems: "You don't have any queues yet",
          noResults: "No queues in your current query",
          fetching: "Getting your queues",
          icon: viList,
        }}
      />
      <FabBar>
        <Button variant="contained" component={NavLink} to="new" startIcon={<Valkyrie icon={viPlus} />}>
          Add
        </Button>
      </FabBar>
    </>
  );
}

export default QueueList;
